import { useTranslation } from 'react-i18next'

import { SectionHeader } from './SectionHeader'
import { Ticket } from './Ticket'

interface TicketsSectionProps {
  tickets: { name: string; price: number; description: string; inactive: boolean }[]
  advancedTicketingEnabled?: boolean
}

export const TicketsSection = ({
  tickets = [],
  advancedTicketingEnabled = false,
}: TicketsSectionProps) => {
  const { t } = useTranslation(['eventManagement'])

  if (!tickets.length || !advancedTicketingEnabled) {
    return null
  }

  return (
    <div className="tickets-section">
      <SectionHeader header={t('eventManagement:common.tickets')} />
      <div className="tickets-section__list">
        {tickets.map((ticket, index) => (
          <Ticket key={`${ticket.name}-${index}`} ticket={ticket} />
        ))}
      </div>
    </div>
  )
}
